import {createSelector} from "@reduxjs/toolkit";
import {ReducerStatuses} from "services/utils/utils";

const baseState = state => state.notifications.list;

export const notificationListLoadingSelector = createSelector([baseState], (state) => {
    return state.status === ReducerStatuses.LOADING && state.current_page === 1;
});
export const notificationListNextLoadingSelector = createSelector([baseState], (state) => {
    return state.status === ReducerStatuses.LOADING && state.current_page !== 1;
});

export const notificationListErrorSelector = createSelector([baseState], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    };
});

export const notificationListData = createSelector([baseState], (state) => {
    return state.list;
});
export const notificationListCurrentPage = createSelector([baseState], (state) => {
    return state.current_page;
});
export const notificationListHasNextPage = createSelector([baseState], (state) => {
    return state.has_next_page;
});
